import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SparklineChartComponent } from './sparkline-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { WrapFnPipe } from '../../pipes';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SparklineChartComponent],
  imports: [CommonModule, NgApexchartsModule, WrapFnPipe, TranslateModule],
  exports: [SparklineChartComponent],
  providers: [DatePipe],
})
export class SparklineChartModule {}
